<template>
  <v-container>
    <v-row>
      <v-col>
        <div id="header_card" class="bg-grey_1 rounded shadowed px-4 py-2">
          <!-- Date de l'évenement -->

          <div class="d-flex flex-wrap justify-space-between align-center">
            <div class="d-flex flex-column justify-center align-start">
              <div class="d-flex flex-wrap justify-start gap align-center mb-2">
                <router-link :to="{ name: 'Home' }" style="text-decoration: none; color: inherit">
                  <h2>{{ mainStore.module.evenement.nom }}</h2>
                </router-link>
                <CalendarCards :debut="mainStore.module.evenement.date_debut"
                  :fin="mainStore.module.evenement.date_fin"></CalendarCards>
              </div>
              <LoginInfos></LoginInfos>
            </div>

            <div class="d-flex flex-column justify-center align-end">
              <!-- Puce de statut des inscriptions globales au module -->
              <StatusInscription></StatusInscription>
            </div>
          </div>
        </div>
        <v-sheet class="bg-grey_2 rounded shadowed px-4 py-2 mt-2" v-if="mainStore.inscription_as_admin"
          variant="tonal">
          <div class="d-flex flex-wrap">
            <v-icon icon="mdi-alert" color="primary-dark"></v-icon>
            <div>
              <p>
                Vous êtes connecté en tant qu'administrateur sur ce formulaire d'inscription. Vous avez la possibilité
                d'inscrire des coureurs sans les limitations d'inscrits sur les courses.
                <br />
                A l'issue du formulaire vous pourrez renseigner les modalités de paiement externe
                (chèque,espèces,virement,invité..)
              </p>
            </div>
          </div>

          <a :href="'https://sportips.fr/inscription/' + mainStore.module.base + '/'"><v-btn color="primary-dark"
              variant="text">Quitter</v-btn></a>
        </v-sheet>

        <v-sheet class="bg-grey_2 rounded shadowed px-4 py-2 mt-2" v-if="mainStore.inscription_vip" variant="tonal">
          <div class="d-flex flex-wrap">
            <v-icon icon="mdi-alert" color="primary-dark" class="mr-2"></v-icon>
            <div>
              Vous avez renseigné un lien privilégié pour ce module (code: {{ mainStore.inscription_vip.token }}).
              {{ mainStore.inscription_vip.get_status() }}
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CalendarCards from "@/components/App/Header/Calendar_Cards.vue";
import StatusInscription from "@/components/App/Header/Status_Inscription.vue";
import LoginInfos from "@/components/Login/Login_Infos.vue";
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";

export default {
  components: { CalendarCards, StatusInscription, LoginInfos },
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMainStore),
  },
};
</script>

<style lang="scss" scoped></style>